// extracted by mini-css-extract-plugin
module.exports = {"footer":"FailedPrintFooter_footer__2w63V","button":"FailedPrintFooter_button__1m95w","button-ltr":"FailedPrintFooter_button-ltr__riFQu"};